import CreateSourcePage from '@/views/sources/CreateSourcePage.vue';
import SourceDetails from '@/views/sources/SourceDetails.vue';
import CreateDestinationPage from '@/views/destinations/CreateDestinationPage.vue';
import DestinationDetails from '@/views/destinations/DestinationDetails.vue';
import AddConnectors from '@/views/connectors/AddConnectors.vue';
import { Permissions } from '@/utils/constants';
import SourcesPage from '@/views/sources/SourcesPage.vue';
import DestinationsPage from '@/views/destinations/DestinationsPage.vue';

export default [
    {
        path: '/connectors/add',
        name: 'add-connectors',
        component: AddConnectors,
        meta: {
            title: 'Add Connectors',
            breadcrumbLabel: 'Add Connectors',
            breadcrumbParent: (route) => {
                // Determine parent based on the tab query parameter or current route path
                const tab = route.query?.tab;
                
                // If no tab query, check the current path to determine context
                if (!tab) {
                    // Check if we're coming from a destination-related route
                    const fromDestinations = route.path.includes('/destinations/') || 
                                            route.matched?.some(match => match.path.includes('/destinations'));
                    return fromDestinations ? 'destinations-list' : 'sources-list';
                }
                
                return tab === 'Destinations' ? 'destinations-list' : 'sources-list';
            },
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.WRITE_SOURCES, Permissions.WRITE_DESTINATIONS],
                    type: 'or'
                }
            }
        }
    },
    // {
    //     path: '/connectors',
    //     name: 'connectors',
    //     component: ConnectorsPage,
    //     meta: {
    //         title: 'Connectors',
    //         breadcrumbLabel: 'Connectors',
    //         requireAuth: true,
    //         accessRules: {
    //             permissions: {
    //                 values: [
    //                     Permissions.READ_DESTINATIONS,
    //                     Permissions.READ_SOURCES,
    //                     Permissions.READ_SOURCE_METRICS,
    //                     Permissions.READ_DESTINATION_METRICS
    //                 ],
    //                 type: 'or'
    //             }
    //         }
    //     }
    // },
    {
        path: '/connectors/sources/new/:connector?',
        name: 'new-source',
        props: (route) => ({
            connector: route.params.connector || null,
            cloneConfig: route.query.cloneConfig || null
        }),
        component: CreateSourcePage,
        meta: {
            title: 'Add Source',
            breadcrumbLabel: 'Add Source',
            breadcrumbParent: 'add-connectors',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.WRITE_SOURCES]
                }
            }
        }
    },
    {
        path: '/connectors/sources/:id',
        name: 'source-details',
        props: (route) => ({
            id: route.params.id
        }),
        component: SourceDetails,
        meta: {
            title: 'Source Details',
            breadcrumbLabel: (route) => (route.params.id ? `Source ${route.params.id}` : 'Source Details'),
            breadcrumbParent: 'sources-list',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.READ_SOURCES, Permissions.READ_SOURCE_METRICS], // write is not required to see the page and will hide the action buttons if needed
                    type: 'and'
                }
            }
        }
    },
    {
        path: '/connectors/destinations/new/:connector?',
        name: 'new-destination',
        props: (route) => ({
            connector: route.params.connector || null,
            cloneConfig: route.query.cloneConfig || null
        }),
        component: CreateDestinationPage,
        meta: {
            title: 'Add Destination',
            breadcrumbLabel: 'Add Destination',
            breadcrumbParent: 'add-connectors',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.WRITE_DESTINATIONS]
                }
            }
        }
    },
    {
        path: '/connectors/destinations/:id',
        name: 'destination-details',
        props: (route) => ({
            id: route.params.id
        }),
        component: DestinationDetails,
        meta: {
            title: 'Destination Details',
            breadcrumbLabel: (route) => (route.params.id ? `Destination ${route.params.id}` : 'Destination Details'),
            breadcrumbParent: 'destinations-list',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.READ_DESTINATIONS, Permissions.READ_DESTINATION_METRICS], // write is not required to see the page and will hide the action buttons if needed
                    type: 'and'
                }
            }
        }
    },
    // Fallback route for connectors - only sources and destinations
    {
        path: '/connectors/sources',
        name: 'sources-list',
        component: SourcesPage,
        meta: {
            title: 'Sources',
            breadcrumbLabel: 'Sources',
            breadcrumbParent: 'connectors',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.READ_SOURCES, Permissions.READ_SOURCE_METRICS],
                    type: 'or'
                }
            }
        }
    },
    {
        path: '/connectors/destinations',
        name: 'destinations-list',
        component: DestinationsPage,
        meta: {
            title: 'Destinations',
            breadcrumbLabel: 'Destinations',
            breadcrumbParent: 'connectors',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.READ_DESTINATIONS, Permissions.READ_DESTINATION_METRICS],
                    type: 'or'
                }
            }
        }
    }
];
